import service from '@/utils/https';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '@/types';
import type { CvAnalysisRequest, CvAnalysisResponse, CvAnalysisDetailResponse, CvAnalysisPrefillResponse } from '@/types/cvAnalysis';

export function analyzeCv(data: CvAnalysisRequest): Promise<AxiosResponse<ApiResponse<CvAnalysisResponse>>> {
  return service({
    url: '/v1/analysis/cv/analyze',
    method: 'post',
    data,
    timeout: 180 * 1000, // 3分钟，与页面超时保持一致
  });
}

export function getCvAnalysisDetail(recordId: string | number): Promise<AxiosResponse<ApiResponse<CvAnalysisDetailResponse>>> {
  return service({
    url: `/v1/analysis/cv/${recordId}`,
    method: 'get',
  });
}

export function getCvAnalysisPrefill(): Promise<AxiosResponse<ApiResponse<CvAnalysisPrefillResponse>>> {
  return service({
    url: '/v1/prefill/cv-analysis',
    method: 'get',
  });
}
